import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: 'https://4a217edf96704617b02ccbd1e7ee1a65@o316041.ingest.sentry.io/4505289237004288',
    integrations: [
        new Sentry.BrowserTracing({
            // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [
                'localhost',
                /^https:\/\/beersport\.test/,
                /^https:\/\/www\.beersport\.test/,
                /^https:\/\/ct-dev\.cz/,
                /^https:\/\/www\.ct-dev\.cz/,
                /^https:\/\/beersport\.com/,
                /^https:\/\/www\.beersport\.com/,
            ],
        }),
        new Sentry.Replay(),
    ],
    environment: __DEPLOYMENT__,
    release: __RELEASE__,
    // Performance Monitoring
    tracesSampleRate: 0.01, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    ignoreErrors: [
        /^Fetch API cannot load https:\/\/firestore\.googleapis\.com/,
    ]
});
